/**
 * AdminGate — route-level auth guard
 *
 * - Bootstrapping: renders a loading screen while session is being restored.
 * - Not authenticated: redirects to /admin/login, preserving
 *   the intended destination in location.state.from for post-login redirect.
 * - Authenticated: renders <Outlet />.
 */
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAdminAuth } from "../../../contexts/AdminAuthContext";
import { useAdminT } from "../../../hooks/useAdminT";

export default function AdminGate() {
  const { isAuthenticated, isBootstrapping } = useAdminAuth();
  const location = useLocation();
  const t = useAdminT();

  if (isBootstrapping) {
    return (
      <div className="h-screen bg-[#F7F6F3] flex items-center justify-center gap-3">
        <span className="w-5 h-5 border-2 border-[#C8B8A6]/30 border-t-[#C8B8A6] rounded-full animate-spin shrink-0" />
        <span className="text-sm text-[#2C2C2C]/40 font-light tracking-wide">
          {t("tabifotoAdmin.auth.bootstrapping")}
        </span>
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <Navigate
        to="/admin/login"
        state={{ from: location.pathname }}
        replace
      />
    );
  }

  return <Outlet />;
}
